import { Link } from 'react-router-dom';
import { Opportunity } from '../../../types';

interface OpportunitiesSectionProps {
  opportunities: Opportunity[];
}

export default function OpportunitiesSection({ opportunities }: OpportunitiesSectionProps) {
  return (
    <div className="card">
      <h2 className="text-lg font-semibold mb-4">
        Opportunities ({opportunities.length})
      </h2>
      {opportunities.length === 0 ? (
        <p className="text-gray-400 text-center py-4">No opportunities found</p>
      ) : (
        <div className="space-y-3 max-h-80 overflow-y-auto">
          {opportunities.map((opp) => (
            <Link
              key={opp.id}
              to={`/opportunities`}
              className="block p-3 bg-surface-50 rounded-lg hover:bg-surface-100 transition-colors"
            >
              <div className="flex items-center justify-between">
                <div>
                  <span
                    className={`px-2 py-0.5 rounded text-xs font-medium ${
                      opp.recommendedAction === 'buy_pm'
                        ? 'bg-green-500/20 text-green-400'
                        : 'bg-red-500/20 text-red-400'
                    }`}
                  >
                    {opp.recommendedAction === 'buy_pm' ? 'BUY' : 'SELL'}
                  </span>
                  <span
                    className={`ml-2 px-2 py-0.5 rounded text-xs ${
                      opp.status === 'active'
                        ? 'bg-blue-500/20 text-blue-400'
                        : 'bg-gray-500/20 text-gray-400'
                    }`}
                  >
                    {opp.status}
                  </span>
                </div>
                <div className="text-right">
                  <div
                    className={`text-lg font-bold ${
                      opp.adjustedEdge > 0.05
                        ? 'text-green-400'
                        : opp.adjustedEdge > 0.03
                        ? 'text-yellow-400'
                        : 'text-gray-400'
                    }`}
                  >
                    {(opp.adjustedEdge * 100).toFixed(1)}%
                  </div>
                  <div className="text-xs text-gray-400">edge</div>
                </div>
              </div>
              <div className="mt-2 grid grid-cols-2 gap-2 text-xs">
                <div>
                  <span className="text-gray-400">Odds Implied:</span>{' '}
                  {(opp.impliedProbOdds * 100).toFixed(1)}%
                </div>
                <div>
                  <span className="text-gray-400">PM Price:</span>{' '}
                  {(opp.impliedProbPolymarket * 100).toFixed(1)}%
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
